/* ===========================
   Group Types — aligned with backend schema
   Categories: sector, tineri, muzical, sbc, altele
   =========================== */

export enum GroupCategory {
  SECTOR = 'sector',
  TINERI = 'tineri',
  MUZICAL = 'muzical',
  SBC = 'sbc',
  ALTELE = 'altele',
}

export interface GroupSection {
  id: string;
  group_id: string;
  name: string;
  sort_order: number;
  color: string | null;
  created_at?: string;
  updated_at?: string;
}

export interface Group {
  id: string;
  name: string;
  description: string | null;
  category: GroupCategory;
  member_count: number;
  members_count?: number;
  /** 0=Sunday, 1=Monday, ... 6=Saturday. NULL = ad-hoc. */
  meeting_day: number | null;
  /** 'weekly' | 'biweekly' | 'monthly' | 'ad_hoc' */
  meeting_cadence: string;
  /** 'roster' | 'headcount' */
  attendance_mode: 'roster' | 'headcount';
  /** Ordered list of voice parts / instrument groups. Empty for non-musical groups. */
  sections?: GroupSection[];
  created_at: string;
  updated_at: string;
}

/**
 * Role values on the `group_members` pivot.
 * `dirijor` (conductor) is only accepted by the backend on muzical groups.
 */
export type GroupMemberRole = 'member' | 'leader' | 'dirijor';

export interface GroupMember {
  id: string;
  member_id: string;
  member_name: string;
  member_photo_url: string | null;
  member_phone: string | null;
  role: GroupMemberRole | string | null;
  section_id: string | null;
  joined_at: string;
}

export interface GroupFormData {
  name: string;
  description?: string | null;
  category: GroupCategory;
}

export interface GroupFilters {
  search?: string;
  category?: GroupCategory;
  ordering?: string;
  page?: number;
  page_size?: number;
  per_page?: number;
}

export interface AddGroupMemberData {
  member_id: string;
  role?: string | null;
  section_id?: string | null;
}
